export enum StorageName {
    AccessToken = "accessToken",
    AppLanguage = "appLanguage",
    ActiveBusinessUnit = "activeBusinessUnit",
    ProductSearchFilterParamsStore = "productSearchFilterParamsStore",
    ProductSearchPaginationStore = "productSearchPaginationStore",
    ProductSearchSortStore = "productSearchSortStore",
    OutboxFilterParamsStore = "outboxFilterParamsStore",
    CustomerSearchFilterParamsStore = "customerSearchFilterParamsStore",
}
